import { render } from "./SoftbreakBlock.vue?vue&type=template&id=24bd1054"
import script from "./SoftbreakBlock.vue?vue&type=script&lang=ts"
export * from "./SoftbreakBlock.vue?vue&type=script&lang=ts"
script.render = render

export default script